import { InjectionToken } from '@angular/core';

export const PORTAL_TELEHEALTH_PANEL_COMPONENT = new InjectionToken(
  'PortalTelehealthPanelComponent'
);
